export default __webpack_public_path__ + "static/media/girl-one.53a59124.png";